export const TALL_CAROUSEL_ASPECT_RATIO = '3x4';
export const SHORT_CAROUSEL_ASPECT_RATIO = '4x3';



// WEBPACK FOOTER //
// ./src/universal/components/Carousel/constants.js